import FiltersOptionState from '../store/schema/FiltersOptionState';
import { action } from 'satcheljs';

export const discardFiltersOption = action('discardFiltersOption');
export const setContactsTrusted = action('setContactsTrusted', (contactsTrusted: boolean) => ({
    contactsTrusted,
}));
export const setTrustedListsOnly = action('setTrustedListsOnly', (trustedListsOnly: boolean) => ({
    trustedListsOnly,
}));
export const setBlockContentFromUnknownSenders = action(
    'setBlockContentFromUnknownSenders',
    (blockContentFromUnknownSenders: boolean) => ({
        blockContentFromUnknownSenders,
    })
);
export const saveFiltersOptionHelper = action(
    'saveFiltersOptionHelper',
    (filtersOptionState: FiltersOptionState) => ({
        filtersOptionState,
    })
);
